<template>
	<div class="work">
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<el-form-item label="工单问题类型" prop="work_type">
				<el-select v-model="ruleForm.work_type" placeholder="状态" @change="onworkType">
					<el-option :label="v.name" :value="v.id" v-for="(v,k) in work_type_list"
						:key="k" v-if="onifoption(v)">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="补偿金额(元)" prop="buchang" v-if="ruleForm.from_type == 1">
				<el-input v-model.number="ruleForm.buchang"></el-input>
				<div class="ts" v-if="isSingle == 0">最多为订单实发总金额的30%</div>
				<div class="ts" v-if="isSingle == 1">最多1000元</div>
			</el-form-item>
			<el-form-item label="备注" prop="remark">
				<el-input type="textarea" placeholder="" v-model="ruleForm.remark" maxlength="500" show-word-limit
					:rows="5"></el-input>
			</el-form-item>
			<el-form-item label="上传图片">
				<div class="imgdiv">
					<img class="img" :src="v" v-for="(v,k) in ruleForm.pics" :key="k">
					<myupload @resultUrl="onimgurl" :uptype="3"></myupload>
				</div>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'Work',
		data() {
			return {
				ruleForm: {
					from_type: "",
					is_single: "",
					trade_no: "",
					work_type: "",
					buchang: 0,
					remark: "",
					pics: []
				},

				rules: {
					work_type: [{
						required: true,
						message: '请选择工单问题类型',
						trigger: 'change'
					}],

					buchang: [{
						required: true,
						message: '金额不能为空',
						trigger: 'blur'
					}, {
						type: 'number',
						message: '必须为数字值',
						trigger: 'blur'
					}],

					remark: [{
						required: true,
						message: '请填写备注',
						trigger: 'blur'
					}]
				},
				
				work_type_list: []
			}
		},

		mounted() {
			if (this.$route.path.indexOf("buyer") != -1) {
				this.ruleForm.from_type = 1;
				this.work_type_list = this.appdata.list.buyer_order_work_type;
			};

			if (this.$route.path.indexOf("seller") != -1) {
				this.ruleForm.from_type = 2;
				this.work_type_list = this.appdata.list.seller_order_work_type;
			}

			this.ruleForm.is_single = this.isSingle;
			if(this.isSingle != 1) {
				this.ruleForm.trade_no = this.mydata.order.trade_no;
			}
			
			if(this.isSingle == 1) {
				this.work_type_list = this.appdata.list.single_order_work_type;
				
			}
		},

		inject: ['appdata'],

		props: {
			isSingle: {
				type: Number,
				default: 1
			},

			mydata: {
				type: Object,
				default: {}
			}
		},

		methods: {
			onworkType(val) {
				if (this.ruleForm.from_type == 1 && val == 1) {
					this.onremark();
				}
			},

			onremark() {
				var text = "";
				text += "订单号：" + this.mydata.order.trade_no + " 这单客户要改地址。" + `\n`;
				text += "原地址为：" + this.mydata.order.recv_name + "，" + this.mydata.order.recv_mobile + "，" + this.mydata.order
					.recv_province + " " + this.mydata.order.recv_city + " " + this.mydata.order.recv_area+ " "+this.mydata.order.recv_address +"（"+this.mydata.order.buyer_remark+"）"+ `\n`+ `\n`;
				// text += "订单号：BBJ26022267004 这单客户要改地址。"+ `\n`;
				// text += "原地址为：财货，13294608385，山西省 忻州市 忻府区 市 忻府区 长征街街道 华江苑东区（样品脏色差瑕疵鞋盒粘胶带写字非原装鞋盒 防伪码用刀刮割的不要发 如发出损失自负）"+ `\n`+ `\n`;
				text += "需要改新地址为："+ `\n`+ `\n`;
				text += "若改地址需要额外支付费用，请渠道提供支付宝账号和对应金额！";
				this.ruleForm.remark = text;
			},
			
			onimgurl(url) {
				this.ruleForm.pics.push(url);
			},
			
			onifoption(obj) {
				// if(obj.id == 1) {
				// 	if(this.mydata.order.order_status == 3 ||this.mydata.order.order_status == 4 ){
				// 		return true
				// 	}
				// 	return false
				// }
				if(this.is_single == 0) {
					if(obj.id == 2) {
						if(this.mydata.order.order_status == 3){
							return true
						}
						return false
					}
				}
				return true;
			},
			
			onsubform() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						obj.pics = obj.pics.join(',');
						this.$axios.post('api/user/start_work', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('申请成功');
								this.$emit('onsub',res.data);
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.ts {
		color: #ff4714;
	}

	/deep/ .el-select {
		width: 300px;
	}
	
	.img {
		width: 178px;
		height: 178px;
		margin-right: 20px;
	}
	
	.imgdiv {
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/common/work.vue